import { IGroup, IItemGroupId, IItemGroup } from '../types';

export const mapGroup = ({
  groups,
  parameterId,
  itemId,
  callback,
}: {
  groups: IGroup[];
  parameterId: number;
  itemId: IItemGroupId;
  callback: (item: IItemGroup) => IItemGroup;
}) =>
  groups.map(group => {
    if (group.parameter.id === parameterId) {
      return {
        ...group,
        itemGroups: group.itemGroups.map(itemGroup => {
          if (String(itemGroup.id) === String(itemId)) {
            return callback(itemGroup);
          }
          return itemGroup;
        }),
      };
    }
    return group;
  });



// WEBPACK FOOTER //
// ./src/views/Admin/ItemGroups/services/mapGroup.ts